import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import '../Footer/Footer.css';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import Spinner from '../Spinner/Spinner';
import BookRoom from '../Bookshelf/BookRoom';
import { withAuth } from "../../app/util/HOC";
import InnerHTML from 'dangerously-set-html-content';
import { handleException } from '../../app/util/util';
import loaderColors1 from '../Spinner/loaderColors1.gif';
export function Dashboard(props) {
    const userVO = JSON.parse(localStorage.getItem('userVO'));
    const keepMeLogIn = localStorage.getItem('keepLoggedIn') ? "true" : "false";
    const [legalNews, setLegalNews] = useState([]);
    const [currLegalNews, setCurrLegalNews] = useState([]);
    const [recommProducts, setRecommProducts] = useState();
    const [legalNewsLength, setLegalNewsLength] = useState(0);
    const [isRecommProduct, setIsRecommProduct] = useState(false);
    const [currLegalNewsLength, setCurrLegalNewsLength] = useState(0);
    const [isDashboardLoading, setIsDashboardLoading] = useState(true);
    const getSessionVO = () => {
        return {
            "appType": "web",
            "deviceMacId": "",
            "keepMeLoggedInFlag": keepMeLogIn,
            "deviceOS": localStorage.getItem('deviceOS'),
            "deviceType": localStorage.getItem('deviceType'),
            "browserName": localStorage.getItem('browserName'),
            "sessionAuthenticationToken": userVO.sessionAuthenticationToken
        }
    }
    useEffect(() => {
        async function fetchDashBoardLegalNews() {
            let reqData = {
                "userVO": {
                    "userId": userVO.userId,
                    "userRole": userVO.userRole,
                    "userType": userVO.userType,
                    "userRoleId": userVO.userRoleId,
                    "userActivityVO": {
                        "lastReadBookId": "",
                        "lastReadPageNum": "",
                        "lastReadChapterId": "",
                        "lastReadSectionId": "",
                        "lastReadParagraphId": "",
                        "lastViewedOutlineId": "",
                        "lastReadSubSectionId": "",
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "EReader",
                        "pageNavigatingTo": "Bookshelf",
                    },
                    "sessionVO": getSessionVO()
                },
            }
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify(reqData),
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            };
            fetch(`${localStorage.getItem('ENV')}/manageRSS/getLegalFeeds`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.status === "true") {
                        if (data.rssMetaDataVOList) {
                            var rssMetaDataVOList = Array.isArray(data.rssMetaDataVOList) ? data.rssMetaDataVOList : [data.rssMetaDataVOList];
                            setLegalNews(rssMetaDataVOList);
                            setLegalNewsLength(rssMetaDataVOList.length);
                            var currInitNews = [], currInitNewsLen = 4;
                            rssMetaDataVOList.map((rssMeta, index) => {
                                if (index <= currInitNewsLen) { currInitNews.push(rssMeta); }
                                return rssMeta;
                            });
                            setCurrLegalNews(currInitNews);
                            setCurrLegalNewsLength(currInitNewsLen);
                        }
                        setIsDashboardLoading(false);
                    } else if (data.wkErrorCode) {
                        handleException(data);
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error)
                });
        }
        async function fetchDashBoardRecomProducts() {
            let reqData = {
                "userVO": {
                    "userId": userVO.userId,
                    "userRole": userVO.userRole,
                    "userType": userVO.userType,
                    "userRoleId": userVO.userRoleId,
                    "userActivityVO": {
                        "lastReadBookId": "",
                        "lastReadPageNum": "",
                        "lastReadChapterId": "",
                        "lastReadSectionId": "",
                        "lastReadParagraphId": "",
                        "lastViewedOutlineId": "",
                        "lastReadSubSectionId": "",
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "EReader",
                        "pageNavigatingTo": "Bookshelf",
                    },
                    "sessionVO": getSessionVO()
                },
                "spotlightFlag": true
            }
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify(reqData),
                headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            };
            fetch(`${localStorage.getItem('ENV')}/managePromo/getPromoForApplication`, requestOptions)
                .then(response => response.json())
                .then(data => {
                    if (data.status === "true" && data.promoVOList) {
                        setIsRecommProduct(true);
                        var promoData = Array.isArray(data.promoVOList) ? data.promoVOList : [data.promoVOList];
                        setRecommProducts(promoData);
                    } else if (data.wkErrorCode) {
                        handleException(data);
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error)
                });
        }
        fetchDashBoardLegalNews();
        fetchDashBoardRecomProducts();
    }, []);
    function handleViewMoreLegalNews() {
        var currMoreNews = currLegalNews,
            currMoreNewsIndex = currLegalNewsLength + 1,
            currMoreNewsLen = currLegalNewsLength + 5;
        legalNews.forEach((legaNews) => {
            if (currMoreNewsIndex <= currMoreNewsLen) {
                currMoreNews.push(legalNews[currMoreNewsIndex]);
                currMoreNewsIndex++;
            }
            return legaNews;
        });
        setCurrLegalNews(currMoreNews);
        setCurrLegalNewsLength(currMoreNewsLen);
    }
    return (
        <React.Fragment>
            <Spinner
                loading={isDashboardLoading}
                imageSrc={loaderColors1}
                overlayBackground="rgba(0,0,0,0.5)"
            />
            <Header userVO={userVO} pageName="dashboard"></Header>
            {
                !isDashboardLoading &&
                <>
                    <div className="Dashboard" style={{ paddingBottom: '60px', minHeight: 'calc(100vh - 50px - 10px)' }}>
                        <div className="container-fluid">
                            <div className="row w-100 m-0">
                                <div id="dashboard-left-container" className="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-xs-12 dashboadLeftMargin">
                                    <div className="row w-100">
                                        <BookRoom {...props} />
                                    </div>
                                    {
                                        isRecommProduct &&
                                        <div className='col p-0 mt-2'>
                                            <div className='recommendedProduct-container'>
                                                <div className='recommProductHeading'>Recommended Products</div>
                                                <div className='recommProductContent recommProductContetInlineBlock'>
                                                    {
                                                        recommProducts && recommProducts.map((recProd, index) => {
                                                            return (
                                                                <div key={'recProd' + index} className="col-xl-6 col-md-6 col-lg-6 col-sm-12 col-xs-12 no-padding recommProductContSect recommProductContetInlineBlock">
                                                                    {
                                                                        recProd.imgS3Path ?
                                                                            <div className="row recommProductContSectRight p-0 m-0">
                                                                                {
                                                                                    recProd.protectedLink ?
                                                                                        <>
                                                                                            <div className="">
                                                                                                <a className="" protectedlink={recProd.protectedLink} promoid={recProd.promoId}>
                                                                                                    <img className="img-responsive" src={recProd.imgS3Path} aria-label={recProd.imgAltText} alt={recProd.imgAltText}></img>
                                                                                                </a>
                                                                                            </div>
                                                                                            <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-xs-6">
                                                                                                <a protectedlink={recProd.protectedLink} promoid={recProd.promoId} aria-label={recProd.headLine}>
                                                                                                    <h2 className="">{recProd.headLine}</h2>
                                                                                                </a>
                                                                                                <div className="recommProductContSectSupport">
                                                                                                    <p>{recProd.supportingText}</p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </> :
                                                                                        <>
                                                                                            <div className="">
                                                                                                <a href={recProd.externalLink} target="_blank" promoid={recProd.promoId}>
                                                                                                    <img className="img-responsive" src={recProd.imgS3Path} aria-label={recProd.imgAltText} alt={recProd.imgAltText}></img>
                                                                                                </a>
                                                                                            </div>
                                                                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                                                                                <a href={recProd.externalLink} target="_blank" promoid={recProd.promoId} aria-label={recProd.headLine}>
                                                                                                    <h2 className="">{recProd.headLine}</h2>
                                                                                                </a>
                                                                                                <div className="recommProductContSectSupport">
                                                                                                    <p>{recProd.supportingText}</p>
                                                                                                </div>
                                                                                            </div>
                                                                                        </>
                                                                                }
                                                                            </div> :
                                                                            <div className="recommProductContSectRight">
                                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                                    {
                                                                                        recProd.protectedLink ?
                                                                                            <a href={recProd.protectedLink} target="_blank" promoid={recProd.promoId} aria-label={recProd.headLine}>
                                                                                                <h2 className="">{recProd.headLine}</h2>
                                                                                            </a> :
                                                                                            <a href={recProd.externalLink} target="_blank" promoid={recProd.promoId} aria-label={recProd.headLine}>
                                                                                                <h2 className="">{recProd.headLine}</h2>
                                                                                            </a>
                                                                                    }
                                                                                    <div className="recommProductContSectSupport">
                                                                                        <p>{recProd.supportingText}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                    }
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div id="dashboard-right-container" className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-xs-6 dashBoardSearchDiv dashBoardDisplayBlock">
                                    {
                                        legalNews &&
                                        <div className='col pr-0'>
                                            <label className="dashBoardSearchLabel pl-0">Search content inside your books and more</label>
                                            <div className="dashBoardSearchIconDiv">
                                                <input data-testid="globalSearchInput" title="Search inside your books for topics, cases, or keywords" className="dashBoardSearchInput" type="text" placeholder="" />
                                                <i data-testid="globalSearch" className='fa fa-search dashBoardSearchIcon' title='Search inside your books for topics, cases, or keywords'></i>
                                            </div>
                                            <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding mt-3 legalNewsDiv'>
                                                <h1 className='legalNewsHeading'>Legal News</h1>
                                                {
                                                    currLegalNews && currLegalNews.map((legNews, index) => {
                                                        return (
                                                            <div key={'legNews' + index} className='legalNewsContainer col-md-12 col-sm-12 col-xs-12 no-padding'>
                                                                <div className="legalNewsDate mTopTen">{legNews.pubDateInAppFormat? legNews.pubDateInAppFormat : ''}</div>
                                                                <div className="legalNewsInfo mTopFive">
                                                                    <a href={legNews.link} target="_blank" title={legNews.channelTitle}><InnerHTML html={legNews.channelTitle} /></a>
                                                                </div>
                                                                <div className="legalNewsInfo mTopFive">
                                                                    <a href={legNews.link} target="_blank" title={legNews.title}><InnerHTML html={legNews.title} /></a>
                                                                </div>
                                                                <div className="legalNewsCont mTopTen"><InnerHTML html={legNews.description} /></div>
                                                                <div className="legalNewsImg mTopFive">
                                                                    <a className="" id="">
                                                                        <img className="pull-right" alt={legNews.rssImageAltText ? legNews.rssImageAltText : (`legalNewsImg${index}`)}
                                                                            title={legNews.rssImageAltText ? legNews.rssImageAltText : (`legalNewsImg${index}`)} src={legNews.rssImagePath}>
                                                                        </img>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                                {
                                                    (legalNewsLength > 5 && currLegalNewsLength < (legalNewsLength - 5)) &&
                                                    <button data-testid="viewMoreNews" className='legalNewsViewMoreBtn' onClick={handleViewMoreLegalNews}>View More News</button>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </>
            }
        </React.Fragment>
    );
}
export default withAuth(Dashboard);